<script lang="jsx">
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { caseOf, map } from '../../lib'
import Retry from '../../components/Retry'
import Input from '../../components/Input'
import Pagination from '../../components/metapic/page/Pagination'

const UserTag = ({ context, userLink }) => (
  <tr>
    <td>{userLink.id}</td>
    <td>{userLink.store}</td>
    <td>
      <a href={userLink.mtpc_url} target="_blank">
        {userLink.text}
      </a>
    </td>
    <td>{userLink.created_at}</td>
    <td>
      <div class="userLinksOptions">
        <button
          class="success"
          onClick={() => {
            context.showLinks(userLink)
          }}
        >
          Manage Links
        </button>
        <button
          class="button"
          onClick={() => {
            context.getLinkClicks(userLink)
          }}
        >
          Show Link Clicks
        </button>
        <button
          className="button"
          onClick={() => {
            context.getLinkClicksCpc(userLink)
          }}
        >
          Link Clicks CPC
        </button>
      </div>
    </td>
  </tr>
)

export default {
  computed: {
    ...mapGetters('links', [
      'userLinksPerPage',
      'pagination',
      'userLinksStatus',
      'linkClicksStatus',
      'calculateClickForm',
      'linkClicks',
      'currentLink',
      'linksStatus',
      'linkClicksCpc',
      'linkClicksCpcStatus',
      'inOpenPaymentCycle',
    ]),
  },
  created() {
    this.update({ path: 'userId', value: this.$route.params.id })
    this.findLinks()
  },
  methods: {
    ...mapActions('links', [
      'findLinks',
      'saveLink',
      'setLink',
      'getLinkClicks',
      'closeLinkClicks',
      'calculateLinkClicks',
      'getLinkClicksCpc',
      'closeLinkClicksCpc',
      'calculateLinkClicksCpc',
      'updateCpc',
      'showLinks',
      'hideLinks',
    ]),
    ...mapMutations('links', ['update']),
    getSourceName(source) {
      const sources = {
        0: 'Other',
        1: 'Instagram',
        2: 'TikTok',
      }
      return sources[source] || 'Unknown'
    },
  },

  render() {
    return (
      <div class="page">
        <h2>Users Links</h2>
        <div class="card page-content">
          {caseOf(this.userLinksStatus, {
            Pending: () => (
              <div class="spinner-container">
                <div class="spinner" />
              </div>
            ),
            Done: () => (
              <div>
                {this.userLinksPerPage && this.userLinksPerPage.length ? (
                  <table style="width: 96%;">
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Store</th>
                        <th>Link</th>
                        <th>Created At</th>
                        <th width="20%">Options</th>
                      </tr>
                    </thead>
                    <tbody>
                      {map(this.userLinksPerPage, (userLink) => {
                        return <UserTag context={this} userLink={userLink} />
                      })}
                    </tbody>
                  </table>
                ) : (
                  <div>No data</div>
                )}
              </div>
            ),
            Error: () => <Retry refresh={this.findLinks} />,
            _: () => null,
          })}

          <div id="linkClicksModal" class="modal fade bd-example-modal-lg" tabIndex="-1" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Link Clicks {this.currentLink ? this.currentLink.id : ''}</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      this.closeLinkClicks()
                    }}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  {caseOf(this.linkClicksStatus, {
                    Pending: () => (
                      <div class="spinner-container">
                        <div class="spinner" />
                      </div>
                    ),
                    Done: (m) => (
                      <div>
                        <table>
                          <thead>
                            <tr>
                              <th>Id</th>
                              <th>Name</th>
                              <th>Count</th>
                            </tr>
                          </thead>
                          <tboby>
                            {map(this.linkClicks, (linkClick) => (
                              <tr>
                                <td>{linkClick.id}</td>
                                <td>{linkClick.name}</td>
                                <td>{linkClick.count}</td>
                              </tr>
                            ))}
                          </tboby>
                        </table>
                        {m ? <div class="success">{m}</div> : ''}
                        {!this.inOpenPaymentCycle ? (
                          <div class="error">Can not recalculate clicks - link’s creation date is outside the unlocked payment period.</div>
                        ) : (
                          ''
                        )}
                      </div>
                    ),
                    Error: () => (
                      <div class="error">
                        Couldn't recalculate link clicks. Check percent value (Use dot separator instead comma for non integer percent)
                      </div>
                    ),
                    _: () => null,
                  })}
                </div>
                <div class="modal-footer">
                  <form class="inline" id="calculateClickForm">
                    <div>
                      <Input
                        label="Percent (%) of manual removed clicks"
                        value={this.calculateClickForm.percent}
                        isPercentage
                        update={(value) => this.update({ path: 'calculateClickForm.percent', value })}
                      />
                    </div>
                    <div>
                      <button
                        type="button"
                        class="success"
                        disabled={!this.inOpenPaymentCycle}
                        onClick={() => {
                          this.calculateLinkClicks()
                        }}
                      >
                        Save changes
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div id="linksModal" class="modal fade bd-example-modal-lg" tabIndex="-1" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Links Options {this.currentLink ? this.currentLink.id : ''}</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      this.hideLinks()
                    }}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div class="modal-body">
                  {caseOf(this.linksStatus, {
                    Pending: () => (
                      <div class="spinner-container">
                        <div class="spinner" />
                      </div>
                    ),
                    Done: () => (
                      <div>
                        <div class="userLinks">
                          <label>
                            <span>Link</span>
                            <input
                              type="text"
                              value={this.currentLink.link}
                              onInput={(e) =>
                                this.setLink({
                                  link: e.target.value,
                                })
                              }
                            />
                          </label>
                        </div>
                        <div class="userLinks">
                          <label>
                            <span>Original</span>
                            <input disabled type="text" value={this.currentLink.original_url} />
                            <button
                              onClick={() => {
                                this.setLink({ link: this.currentLink.original_url })
                              }}
                            >
                              Use as link
                            </button>
                          </label>
                        </div>
                        <div class="userLinks">
                          <label>
                            <span>Affiliate</span>
                            <input disabled type="text" value={this.currentLink.affiliate_link} />
                            <button
                              onClick={() => {
                                this.setLink({ link: this.currentLink.affiliate_link })
                              }}
                            >
                              Use as link
                            </button>
                          </label>
                        </div>
                      </div>
                    ),
                    _: () => null,
                  })}
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="success"
                    onClick={() => {
                      this.saveLink()
                    }}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div id="linkClicksCpcModal" class="modal fade bd-example-modal-lg" tabIndex="-1" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Link Clicks CPC {this.currentLink ? this.currentLink.id : ''}</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      this.closeLinkClicksCpc()
                    }}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  {caseOf(this.linkClicksCpcStatus, {
                    Pending: () => (
                      <div class="spinner-container">
                        <div class="spinner" />
                      </div>
                    ),
                    Done: (m) => (
                      <div>
                        <table>
                          <thead>
                            <tr>
                              <th>Source</th>
                              <th>Offer IDs</th>
                              <th>CPC</th>
                              <th>Count</th>
                            </tr>
                            {map(this.linkClicksCpc, (linkClickCpc, key) => (
                              <tr>
                                <td>{this.getSourceName(linkClickCpc.source)}</td>
                                <td>{linkClickCpc.offer_ids}</td>
                                <td class="link-click-cpc-input">
                                  <Input
                                    label=""
                                    value={linkClickCpc.user_revenue_cpc_new}
                                    update={(value) => this.updateCpc({ key, value })}
                                  />
                                  <p class="link-click-cpc-currency">
                                    {this.currentLink.currency_iso_code ? this.currentLink.currency_iso_code : ''}
                                  </p>
                                </td>
                                <td>{linkClickCpc.count}</td>
                              </tr>
                            ))}
                          </thead>
                        </table>
                        <form className="inline" id="calculateCpcForm">
                          {m ? <div class="success">{m}</div> : ''}
                          {!this.inOpenPaymentCycle ? (
                            <div class="error">
                              Can not recalculate clicks - link’s creation date is outside the unlocked payment period.
                            </div>
                          ) : (
                            ''
                          )}
                          <div>
                            <button
                              type="button"
                              class="success"
                              disabled={!this.inOpenPaymentCycle}
                              onClick={() => {
                                this.calculateLinkClicksCpc()
                              }}
                            >
                              Recalculate
                            </button>
                          </div>
                        </form>
                      </div>
                    ),
                    Error: () => <div class="error">Couldn't get/calculate link clicks cpc</div>,
                    _: () => null,
                  })}
                </div>
              </div>
            </div>
          </div>

          <div id="modalBackdrop" class="modal-backdrop fade"></div>
        </div>
        <Pagination currentPage={this.pagination.current} lastPage={this.pagination.last} onPageChange={this.findLinks} />
      </div>
    )
  },
}
</script>
